import DriverProofPending from './pages/driver/DriverProofPending';
import DriverPending from './pages/driver/DriverPending';
import DriverRoutes from './pages/driver/DriverRoutes';
import DriverRoute from './pages/driver/DriverRoute';
import DriverStop from './pages/driver/DriverStop';
import WorkList from './pages/WorkList';
/**
 * WHENLY WAREHOUSE PWA
 *
 * Mobile-first app for warehouse operations:
 * - Pick list management
 * - Barcode scanning
 * - Stock takes
 * - Dispatch and signatures
 *
 * TEMP_URL: Update VITE_API_URL when you get a custom domain
 */

import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { warehouseReturnTo } from './navigation';
import AppUpdate from './updates/AppUpdate';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PickList from './pages/PickList';
import PickItem from './pages/PickItem';
import StockEnrollment from './pages/StockEnrollment';
import OpeningStock from './pages/OpeningStock';
import WarehouseReceiving from './pages/WarehouseReceiving';
import SupplierReturnSetup from './pages/SupplierReturnSetup';
import BinMoves from './pages/BinMoves';
import DamageReports from './pages/DamageReports';
import PurchaseDamageHolding from './pages/PurchaseDamageHolding';
import SupplierDamageHolding from './pages/SupplierDamageHolding';
import StockTake from './pages/StockTake';
import Dispatch from './pages/Dispatch';
import Signature from './pages/Signature';
import Scanner from './pages/Scanner';
import PutAway from './pages/PutAway';
import PutAwayItem from './pages/PutAwayItem';

// Context
import { AuthProvider, useAuth } from './context/AuthContext';

function AppRoutes() {
  const { isAuthenticated, loading, shops, currentShop, selectShop } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated && location.pathname !== '/login') {
    return <Navigate to="/login" replace state={{ returnTo: warehouseReturnTo(location.pathname + location.search + location.hash) }} />;
  }

  return (
    <>
    <AppUpdate />
    {isAuthenticated && <div style={{ padding: '0.75rem' }}>
      <label>Warehouse account <select value={currentShop?.id || ''} onChange={e => selectShop(e.target.value)}>
        <option value="" disabled>Choose an account</option>
        {shops.map(shop => <option key={shop.id} value={shop.id}>{shop.name}</option>)}
      </select></label>
      {!shops.length && <p>Set up your warehouse account at <a href="https://app.whenlyapp.com">Whenly</a> first.</p>}
    </div>}
    {isAuthenticated && <><DriverPending key={currentShop?.id} /><DriverProofPending key={'proof-'+currentShop?.id}/></>}
    <Routes key={currentShop?.id}>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Dashboard />} />
      <Route path="/driver" element={<DriverRoutes />} />
      <Route path="/driver/routes/:routeId" element={<DriverRoute />} />
      <Route path="/driver/routes/:routeId/stops/:stopId" element={<DriverStop />} />
      <Route path="/pick-lists" element={<WorkList />} />
      <Route path="/stock-enrollment/:productId?" element={<StockEnrollment />} />
      <Route path="/opening-stock/:productId?" element={<OpeningStock />} />
      <Route path="/receiving/:receiptId?" element={<WarehouseReceiving />} />
      <Route path="/supplier-return-setup" element={<SupplierReturnSetup />} />
      <Route path="/bin-moves/:moveId?" element={<BinMoves />} />
      <Route path="/purchase-holdings/:holdId" element={<PurchaseDamageHolding />} />
      <Route path="/supplier-rejected/:itemId" element={<SupplierDamageHolding />} />
      <Route path="/damage-reports/:reportId?" element={<DamageReports />} />
      <Route path="/stock-takes" element={<WorkList />} />
      <Route path="/dispatches" element={<WorkList />} />
      <Route path="/pick/:pickListId" element={<PickList />} />
      <Route path="/pick/:pickListId/item/:itemId" element={<PickItem />} />
      <Route path="/stock-take/:stockTakeId" element={<StockTake />} />
      <Route path="/dispatch/:dispatchId" element={<Dispatch />} />
      <Route path="/signature/:dispatchId" element={<Signature />} />
      <Route path="/scanner" element={<Scanner />} />
      <Route path="/put-away" element={<PutAway />} />
      <Route path="/put-away/:taskId" element={<PutAwayItem />} />
    </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <div className="app">
        <AppRoutes />
      </div>
    </AuthProvider>
  );
}
